import { createContext } from 'react';

import type { XYChartColorPalette } from '../types/xy-chart.js';

export const XYChartColorPaletteContext = createContext<
  XYChartColorPalette | undefined
>(undefined);
XYChartColorPaletteContext['displayName'] = 'XYChartColorPaletteContext';
